import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingStateService implements OnDestroy {
  public loadingSource: BehaviorSubject<boolean>;

  constructor() {
    this.loadingSource = new BehaviorSubject<boolean>(false);
  }

  /**
   * Inicia el skeleton (muestra loading).
   */
  public start(): void {
    this.loadingSource.next(true);
  }

  /**
   * Finaliza el skeleton (muestra contenido real).
   */
  public stop(): void {
    this.loadingSource.next(false);
  }

  /**
   * Completa el observable de skeleton.
   */
  public complete(): void {
    this.loadingSource.next(false);
  }

  public ngOnDestroy(): void {
    this.complete();
    this.loadingSource.complete();
  }
}
